export const TABS_LAYOUT = {
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical',
};

export const TABS_MODE = {
  SWITCH: 'switch',
  SCROLL: 'scroll',
};
